/**
 * IconifyアイコンをSVG Blobに変換する
 * Iconify APIを使ってSVGを取得し、グレー色に変換する
 * @param iconName アイコン名（例: "mdi:account"）
 * @param size アイコンのサイズ（デフォルト: 20）
 * @returns SVG Blob
 */
export const convertIconifyToSvgBlob = async (
  iconName: string,
  size: number = 20
): Promise<Blob> => {
  // Iconify APIからSVGを取得
  const apiUrl = `https://api.iconify.design/${iconName}.svg?height=${size}`

  try {
    const response = await fetch(apiUrl)
    if (!response.ok) {
      throw new Error(`Failed to fetch icon: ${response.statusText}`)
    }

    const svgText = await response.text()

    // グレー色 (#808080) に変換
    // 1. currentColor を #808080 に置換
    // 2. fill属性の色を #808080 に置換
    // 3. stroke属性の色を #808080 に置換
    let grayedSvgText = svgText
      .replace(/currentColor/g, '#808080')
      .replace(/fill="[^"]*"/g, 'fill="#808080"')
      .replace(/stroke="[^"]*"/g, 'stroke="#808080"')

    // SVG Blobを生成
    return new Blob([grayedSvgText], {
      type: 'image/svg+xml;charset=utf-8',
    })
  } catch (error) {
    throw new Error(`Failed to convert icon to SVG: ${error}`)
  }
}
